import _slicedToArray from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _rightColContent;
var __jsx = React.createElement;
/** @format */

import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import Router from 'next/router';
import { useDecision } from '@optimizely/react-sdk';
import { Loading } from "../../Merchant/Linking/Loading";
import { fetchMemberStatus, ERROR, SUCCESS, NOT_FOUND, ALREADY_LINKED, LOADING } from "../../../reducers/partnerLinking";
import { openLoginModal as openLoginModalAction } from "../../../reducers/user";
import ArrowLink from "../../_global/ArrowLink";
import isExternalUrl from "../../../utils/isExternalUrl";
var wwPartnerLogos4 = "/static/logos/ww-partner-logos-4.png";
var onlineIcon = "/static/merchant/online.png";
var inStoreIcon = "/static/merchant/instore.png";
var woolWorthCardIcon = "/static/logos/everyday-rewards-small-card-2.svg";
import EventTrackingHelper from "../../../utils/trackingUtilities";
import { OPTIMIZELY_FLAGS, FEATURE_FLAG_DEFAULTS } from "../../../lib/optimizelyClient";
import { SuccessTick, MerchantPanelContainerWithHeader, MerchantPanelContainer, LeftContainer, RightContainer, PStyled, ButtonStyled, LinkStyled, MerchantLogos, LoadingContainer } from "./style";
import PanelHeading from "./PanelHeading";
import PanelHeadingDesc from "./PanelHeadingDesc";
import PanelShopMethod from "./PanelShopMethod";
import { stateToPropsWoolworth, useMount } from "../utilsWoolworths";
var leftColContent = {
  heading: ['Earn', '1,000', 'Qantas Points'],
  headingDescription: 'every time you reach 2,000 Everyday Rewards points*',
  findOutlinkLabel: 'Find out more',
  findoutLinkUrl: '/everyday-rewards',
  methodLabel: 'Online + In Store',
  methodImgs: [onlineIcon, inStoreIcon, woolWorthCardIcon]
};
var rightColContent = (_rightColContent = {}, _defineProperty(_rightColContent, NOT_FOUND, {
  description: ['Link your Everyday Rewards account to earn Qantas Points with these brands'],
  link: '',
  linkLabel: 'Link account',
  linkURL: '/partner-host?id=null&ct=link',
  header: 'Set yourself up to earn Qantas Points with Everyday Rewards',
  joinURL: '/partner-host?id=null&ct=join',
  event: 'EDR not linked',
  eventOnClick: 'EDR CTA link'
}), _defineProperty(_rightColContent, ERROR, {
  description: ['Choose Qantas Points with Everyday Rewards and start earning with these brands'],
  link: '',
  linkLabel: 'Switch to Qantas Points',
  linkURL: '/link',
  header: 'Set yourself up to earn Qantas Points with Everyday Rewards',
  joinURL: '/partner-host?id=null&ct=join',
  eventOnClick: 'EDR CTA switch to QF points'
}), _defineProperty(_rightColContent, SUCCESS, {
  description: ['Choose Qantas Points with Everyday Rewards and start earning with these brands'],
  link: '',
  linkLabel: 'Switch to Qantas Points',
  linkURL: '/link',
  header: 'Set yourself up to earn Qantas Points with Everyday Rewards',
  event: 'EDR linked not QF points',
  eventOnClick: 'EDR CTA switch to QF points'
}), _defineProperty(_rightColContent, ALREADY_LINKED, {
  icon: __jsx(SuccessTick, null),
  description: ["You're earning Qantas Points with Everyday Rewards. Scan your Everyday Rewards Card at these locations."],
  link: '',
  linkLabel: 'SHOP WOOLWORTHS',
  linkURL: 'https://www.woolworths.com.au/',
  event: 'EDR linked earning QF points',
  eventOnClick: 'EDR CTA Shop Woolworths'
}), _rightColContent);
var MerchantPanel = function MerchantPanel(_ref) {
  var getStatus = _ref.getStatus,
    openLoginModal = _ref.openLoginModal,
    statusCode = _ref.statusCode,
    _ref$authorized = _ref.authorized,
    authorized = _ref$authorized === void 0 ? false : _ref$authorized,
    _ref$authenticated = _ref.authenticated,
    authenticated = _ref$authenticated === void 0 ? false : _ref$authenticated,
    _ref$merchantId = _ref.merchantId,
    merchantId = _ref$merchantId === void 0 ? 'woolworths' : _ref$merchantId;
  useMount(authenticated, authorized, merchantId, getStatus);
  useEffect(function () {
    // scenario 2.1
    [NOT_FOUND, SUCCESS, ALREADY_LINKED].includes(statusCode) && EventTrackingHelper.trackGenericAction(rightColContent[statusCode].event, {
      edr_status: rightColContent[statusCode].event
    });
  }, [statusCode]);
  var _useDecision = useDecision(OPTIMIZELY_FLAGS.WOOLWORTHS_MAINTENANCE),
    _useDecision2 = _slicedToArray(_useDecision, 1),
    isInMaintenanceMode = _useDecision2[0].enabled;
  var _useDecision3 = useDecision(OPTIMIZELY_FLAGS.WOOLWORTHS_MAINTENANCE_LINK),
    _useDecision4 = _slicedToArray(_useDecision3, 1),
    _useDecision4$0$varia = _useDecision4[0].variables.value,
    ctaLinkForMaintenanceMode = _useDecision4$0$varia === void 0 ? FEATURE_FLAG_DEFAULTS[OPTIMIZELY_FLAGS.WOOLWORTHS_MAINTENANCE_LINK] : _useDecision4$0$varia;
  var linkAccount = function linkAccount() {
    if (isInMaintenanceMode) {
      window.open(ctaLinkForMaintenanceMode, '_blank');
      return;
    }
    var content = rightColContent[statusCode];
    if (!content) {
      content = rightColContent[ERROR];
    }
    // scenario 2.3.1, 2.3.2 and 2.3.4 - 'EDR CTA switch to QF points', 'EDR CTA Shop Woolworths'	and 'EDR CTA link'
    content.event && EventTrackingHelper.trackGenericAction(content.eventOnClick, {
      cta_name: content.eventOnClick
    });
    if (!authorized) {
      openLoginModal(content.linkURL || '/');
      return;
    }
    if (isExternalUrl(content.linkURL)) {
      window.open(content.linkURL);
    } else {
      window.location.href = content.linkURL;
    }
  };
  var joinAccount = function joinAccount() {
    if (isInMaintenanceMode) {
      window.open(ctaLinkForMaintenanceMode, '_blank');
      return;
    }
    // scenario 2.3.1 'EDR CTA join'
    EventTrackingHelper.trackGenericAction('EDR CTA join', {
      cta_name: 'EDR CTA join'
    });
    var content = rightColContent[statusCode];
    if (!content) {
      content = rightColContent[ERROR];
    }
    if (!authenticated) {
      openLoginModal(content.joinURL);
      return;
    }
    window.location.href = content.joinURL;
  };
  var renderRightColContent = function renderRightColContent(content) {
    return __jsx(React.Fragment, null, content.icon, __jsx(PStyled, null, content.description.map(function (c, i) {
      return __jsx("div", {
        key: i
      }, c);
    })), __jsx(MerchantLogos, {
      src: wwPartnerLogos4,
      alt: "Woolworths merchant logos"
    }), __jsx(ButtonStyled, {
      primary: true,
      onPress: linkAccount
    }, content.linkLabel), content.joinURL && __jsx(LinkStyled, {
      link: true,
      onPress: joinAccount
    }, ' ', "Join Everyday Rewards"));
  };
  var content = rightColContent[statusCode];
  if (!content) {
    content = rightColContent[ERROR];
  }
  return __jsx(MerchantPanelContainerWithHeader, null, content && content.header && __jsx("h2", null, content.header), __jsx(MerchantPanelContainer, null, __jsx(LeftContainer, null, leftColContent.heading && __jsx(PanelHeading, {
    content: leftColContent.heading
  }), leftColContent.headingDescription && __jsx(PanelHeadingDesc, {
    content: leftColContent.headingDescription
  }), __jsx(ArrowLink, {
    clickEvent: function clickEvent(e) {
      // scenario 2.2 'EDR find out more'
      e.preventDefault();
      EventTrackingHelper.trackGenericAction('EDR find out more', {
        cta_name: 'EDR find out more'
      });
      Router.push(leftColContent.findoutLinkUrl);
    },
    href: leftColContent.findoutLinkUrl,
    text: leftColContent.findOutlinkLabel
  }), __jsx(PanelShopMethod, {
    methodLabel: leftColContent.methodLabel,
    methodImgs: leftColContent.methodImgs
  })), __jsx(RightContainer, null, statusCode === LOADING ? __jsx(LoadingContainer, null, __jsx(Loading, null)) : renderRightColContent(content))));
};
var mapStateToProps = stateToPropsWoolworth;
var mapDispatchToProps = {
  getStatus: fetchMemberStatus,
  openLoginModal: openLoginModalAction
};
export default /*#__PURE__*/memo(connect(mapStateToProps, mapDispatchToProps)(MerchantPanel));